import { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Renders lines with an overflow-hidden mask and animates each line up.
// On-load reveal by default; when `inView` is set, reveal triggers when the
// wrapper (stable bounding rect) enters the viewport.
export const RevealText = ({
  lines = [],
  className = "",
  lineClassName = "",
  inView = false,
  delay = 0,
  stagger = 0.09,
  as: Tag = "span",
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-12% 0px -12% 0px" });
  const active = inView ? isInView : true;

  const MotionTag = motion[Tag] || motion.span;

  return (
    <MotionTag ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={active ? { y: "0%" } : { y: "110%" }}
            transition={{
              duration: 0.9,
              ease: [0.22, 1, 0.36, 1],
              delay: delay + i * stagger,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
};

export default RevealText;
